var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateDownloadBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.815,
    height: 68.178,
    viewBox: "0 0 56.815 68.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-md-download",
    d: "M63.565,28.558H47.337V4.5H22.978V28.558H6.75l28.407,28.07ZM6.75,64.653v8.025H63.565V64.653Z",
    transform: "translate(-6.75 -4.5)",
    fill: "#ddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateDownloadBtn);
export default __webpack_public_path__ + "static/media/certificate_download_btn.c88da107.svg";
export { ForwardRef as ReactComponent };